import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ILocation } from '../model/location.interface';
import {
  BehaviorSubject,
  catchError,
  Observable,
  retry,
  throwError,
} from 'rxjs';
import { environment } from '@environment';
import { HTTP_PIPE_RETRY, LOCATIONS_ENDPOINT } from '@commons/constants';

/**
 * Service for fetching and managing location data.
 */
@Injectable({
  providedIn: 'root',
})
export class LocationService {
  locations: ILocation[] = [];
  locations$: BehaviorSubject<ILocation[]> = new BehaviorSubject<ILocation[]>(
    [],
  );

  /**
   * Initializes LocationService.
   * @param httpClient Angular HTTP client.
   */
  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Fetches all locations from the provided API endpoint.
   * @param endpoint The API endpoint to retrieve the location data.
   * @returns An observable that emits an array of locations.
   */
  getAllLocations(endpoint: string): Observable<ILocation[]> {
    return this.httpClient
      .get<ILocation[]>(`${environment.awsServicesBaseUrl}/${endpoint}`)
      .pipe(
        retry(HTTP_PIPE_RETRY),
        catchError((error: HttpErrorResponse) => {
          return throwError(() => error);
        }),
      );
  }

  /**
   * Loads locations from the default locations endpoint and updates the locations subject.
   */
  getLocations() {
    this.getAllLocations(LOCATIONS_ENDPOINT).subscribe({
      next: (locations) => {
        this.locations = locations;
        this.locations$.next(this.locations);
      },
      error: (_error) => {
        console.log('Error: ', _error);
      },
    });
  }
}
